export function toUtcDate(date: Date): Date {
  const preferredOffsetMinutes = Number(localStorage.getItem('tz') ?? 0);
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    ) - preferredOffsetMinutes * 60000
  );
}
export function formatDateDDMMMYYYY(date: Date | string): string {
  if (!date) return '';

  const d = typeof date === 'string' ? new Date(date) : date;

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });

  // If there is a dot after the month it removes it
  return formatter.format(d).replace('.', '');
}

export function formatDateRange(startDate: Date | string, endDate: Date | string): string {
  if (!startDate || !endDate) return '';

  const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

  const formattedFrom = formatDateDDMMMYYYY(start);
  const formattedTo = formatDateDDMMMYYYY(end);

  //same day
  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()
  ) {
    return formattedFrom;
  }

  //date range
  return `${formattedFrom} - ${formattedTo}`;
}

export function processDateRange(input: { dateFrom: string | Date; dateTo: string | Date }): {
  startDate?: Date;
  endDate?: Date;
  selectedDate: string;
} {
  if (!input.dateFrom && !input.dateTo) {
    return { startDate: undefined, endDate: undefined, selectedDate: '' };
  }

  const rawStart = new Date(input.dateFrom);
  const rawEnd = new Date(input.dateTo);

  return {
    startDate: toUtcDate(rawStart),
    endDate: toUtcDate(rawEnd),
    selectedDate: formatDateRange(rawStart, rawEnd),
  };
}
